/*** IMPORTS FROM imports-loader ***/
var define = false;

var Option = function Option() {
  return null;
};

export default Option;



//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-mentions/es/Option.js
// module id = 1153
// module chunks = 0